module.exports = __webpack_public_path__ + "static/media/appaloosa.bbabd655.glb";